import { useContext } from 'react'

import { UserDataContext } from 'providers/userData/UserDataContext'

export const useAuth = () => useContext(UserDataContext)
